"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "zumpano": {
    "32803019": [{
      "hkey": "9e503feb",
      "slug": "menna-vence",
      "name": "Menna-Vence",
      "primary": true,
      "skipSearch": false
    }],
    "mennavence": [{
      "hkey": "9e503feb",
      "slug": "menna-vence",
      "name": "Menna-Vence",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6423f796": [{
      "hkey": "2104cd99",
      "slug": "zumpano",
      "name": "Zumpano",
      "primary": true,
      "skipSearch": false
    }],
    "padula": [{
      "hkey": "2104cd99",
      "slug": "zumpano",
      "name": "Zumpano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;